import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async readAllInsuranceTypes(variables) {
		const res = await gql({
			query: query.readAllInsuranceTypes,
			variables
		})
		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "productTypes"
		})
	},

	async createInsuranceType(variables) {
		const res = await gql({
			query: mutation.createInsuranceType,
			variables
		})
		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	},

	async createInsurer(variables) {
		const res = await gql({
			query: mutation.createInsurer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createInsurer"
		})
	},

	async deleteInsuranceType(variables) {
		const res = await gql({
			query: mutation.deleteInsuranceType,
			variables
		})
		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	},

	async localizeInsurer(variables) {
		const res = await gql({
			query: mutation.localizeInsurer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "upsertL10n"
		})
	},

	async localizeInsuranceType(variables) {
		const res = await gql({
			query: mutation.localizeInsuranceType,
			variables
		})
		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "upsertL10n"
		})
	},

	async insurers(variables) {
		const res = await gql({
			query: query.insurers,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "insurers"
		})
	},

	async deleteInsurer(variables) {
		const res = await gql({
			query: mutation.deleteInsurer,
			variables
		})
		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	}
}
